module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CreateInspection"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Shibaken",
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', [_c('img', {
    staticClass: "modal-content",
    attrs: {
      "src": require("../../../assets/img/shibaken.jpg")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dadbc670"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/legal_case/magic.vue
// module id = 1059
// module chunks = 0